import { timelineSteps } from "@/mocks/homeContent";

export default function TimelineSection() {
  return (
    <section id="timeline" className="w-full bg-background-50">
      <div className="container-x py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_320px]">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-accent-600">
              <i className="ri-time-line" />
              事件还原
            </p>
            <h2 className="font-heading mt-2 text-2xl font-black md:text-4xl">深挖还原 · 事件时间线</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-500">
              以「一纸声明三处反转」为例，把深扒的完整链路摊成五帧。脉络清楚，深挖帖才有说服力。
            </p>

            <ol className="relative mt-8 ml-1 border-l-2 border-background-200">
              {timelineSteps.map((s, i) => (
                <li key={s.title} className="relative mb-7 pl-7 last:mb-0 md:pl-9">
                  <span className="absolute -left-[9px] top-1 flex h-4 w-4 items-center justify-center rounded-full bg-background-100">
                    <span className="h-2.5 w-2.5 rounded-full bg-accent-500 ring-4 ring-accent-100" />
                  </span>
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="text-xs font-bold text-accent-600">STEP {String(i + 1).padStart(2, "0")}</span>
                    <span className="text-xs text-foreground-400">{s.time}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-semibold text-secondary-900">
                      {s.tag}
                    </span>
                  </div>
                  <h3 className="font-heading mt-1.5 text-lg font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1 text-sm leading-relaxed text-foreground-600">{s.text}</p>
                </li>
              ))}
            </ol>
          </div>

          <aside className="h-fit lg:sticky lg:top-24">
            <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
              <div className="flex items-center gap-2 bg-foreground-950 px-5 py-3.5">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className="ri-folder-2-fill" />
                </span>
                <div>
                  <p className="text-xs text-foreground-300">起底档案编号</p>
                  <p className="font-heading text-sm font-black text-background-50">69-DIG-2026-017</p>
                </div>
              </div>
              <div className="space-y-3 p-5">
                {[
                  ["深挖帖状态", "已进入追踪复盘"],
                  ["还原链长度", "5 帧 · 可续写"],
                  ["证据可信度", "交叉核验通过"],
                  ["现场热度", "极高 92"],
                ].map(([k, v]) => (
                  <div key={k} className="flex items-center justify-between text-[13px]">
                    <span className="text-foreground-500">{k}</span>
                    <span className="font-semibold text-foreground-950">{v}</span>
                  </div>
                ))}
                <a
                  href="#evidence"
                  className="mt-2 inline-flex w-full items-center justify-center gap-2 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  查看证据拼图
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}